import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth";
import user from "./user";
import profile from "./profile";
import shared from "./shared";
import acessos from "./acessos";
import concursos from "./concursos";
import resetPassword from "./resetPassword";
import empresa from "./empresa";
import saque from "./saque";
import conciliacao from "./conciliacao";
import caixa from "./caixa";
import relatorios from "./relatorios";
import estatisticas from "./estatisticas";
import bolao from "./bolao";
import clientes from "./clientes";
import Padroes from "./padroes";
import ApoiadorPlanos from "./apoiadorplanos";
import ConcursoLotojr from "./concursolotojr";
import SaqueLotojr from "./saquelotojr";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    auth,
    user,
    profile,
    shared,
    acessos,
    concursos,
    resetPassword,
    empresa,
    saque,
    conciliacao,
    caixa,
    relatorios,
    estatisticas,
    bolao,
    clientes,
    Padroes,
    ApoiadorPlanos,
    ConcursoLotojr,
    SaqueLotojr,
  },
});
